import * as React from 'react';
import { logout } from '../../core/Api';
import { useIsAuthenticated, useSetIsAuthenticated } from '../../state/context';

const AuthButton = () => {
  const isAuthenticated = useIsAuthenticated();
  const setIsAuthenticated = useSetIsAuthenticated();

  const handleLogin = () => {
    const url = process.env.SSO_LOGIN_URL as string;
    window.location.replace(url);
  };

  const handleLogout = () => {
    logout()
      .finally(() => {
        setIsAuthenticated(false);
      })
  };

  return (
    <button
      className="text-xxs uppercase flex items-center font-medium"
      onClick={isAuthenticated ? handleLogout : handleLogin}
    >
      {isAuthenticated ? 'Log ud' : 'Log ind'}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="10"
        fill="none"
        className="ml-2 block mb-px -mt-px"
        viewBox="0 0 10 10"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.3"
          d="M8 4.6H2c-.4 0-.8.4-.8.8v3c0 .4.4.8.9.8h5.8c.5 0 .8-.4.8-.9V5.4c0-.4-.3-.8-.8-.8zm-5 0V2.9a2 2 0 114 0v1.7"
        />
      </svg>
    </button>
  );
};

export default AuthButton;
